// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 25732 ? "f4bee63f" : chunkId) + "." + {"25732":"dbb144ab5e7f7f45","31214":"8a353c586db83355","34595":"d29926c79881fdb1","59031":"d9aa018cc1e18687","86013":"bbb471fa9c0e5004"}[chunkId] + ".js";
};